import PopupComponent from '@components/std-components/Popup'
import { Tooltip, makeStyles } from '@material-ui/core'
import React from 'react'
import { FilterIcon } from '@core'
import { useTranslation } from 'react-i18next'
import MaterialUIBadge from '@material-ui/core/Badge'
import { CNFProductFilterContainer } from './CNFProductFilterContainer'

const useStyles = makeStyles(theme => ({
  filterIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 50,
    '&:hover': {
      background: '#EEEEEE'
    }
  }
}))

export const CNFProductFilterPopup = ({ popupProps, filterProps }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { badgeCount, onClose } = popupProps

  return (
    <PopupComponent
      trigger={
        <Tooltip title={t('common.label.filters', 'Filters')}>
          <MaterialUIBadge variant='dot' invisible={!badgeCount} color='primary'>
            <div className={classes.filterIcon}>
              <FilterIcon />
            </div>
          </MaterialUIBadge>
        </Tooltip>
      }
      contentStyle={{
        width: '420px',
        height: '85%',
        padding: 0,
        left: 'auto',
        right: 0,
        marginRight: 5,
        boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.15)'
      }}
      nested={true}
      arrow={false}
      {...popupProps}
    >
      <CNFProductFilterContainer {...filterProps} onClose={onClose} />
    </PopupComponent>
  )
}
